import { render, staticRenderFns } from "./BusinessType.vue?vue&type=template&id=204e51a3&"
import script from "./BusinessType.vue?vue&type=script&lang=js&"
export * from "./BusinessType.vue?vue&type=script&lang=js&"
import style0 from "./BusinessType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports